module.exports = __webpack_public_path__ + "static/media/wonder_swirl_diffuse.b40f2c5c.png";